import React from 'react';
import PropTypes from 'prop-types';
import { Tile, TileContent, TileText } from '@one-thd/sui-atomic-components';
import { AssistantIcon } from '../../assets/AssistantIcon';

const TileButton = ({
  label,
  value,
  onClick,
  truncate,
  lineClamp,
  withIcon = true,
  fullWidth = false,
  ...props
}) => {
  // eslint-disable-next-line max-len
    const pillClasses = `sui-min-h-11 sui-bg-primary sui-rounded-lg sui-border-solid sui-rounded-base sui-text-primary hover:sui-outline hover:sui-outline-2 hover:-sui-outline-offset-2 focus-visible:sui-outline focus-visible:sui-outline-input-focus focus-visible:sui-outline-4 focus-visible:-sui-outline-offset-4 sui-border-1 sui-border-input-primary hover:sui-outline-button-hover-accent${fullWidth ? ' sui-grow' : ''}`;
    const contentClasses = `sui-flex sui-h-full sui-w-full sui-p-2 sui-rounded-lg group-active:sui-backdrop-brightness-darken group-active:sui-transform group-active:sui-ease-out group-active:sui-duration-150 sui-items-center sui-gap-2${fullWidth ? ' sui-justify-center' : ''}`;

  return (
    <Tile
      className={pillClasses}
      onClick={onClick}
      value={value}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <TileContent className={contentClasses}>
        {withIcon && <AssistantIcon width="16px" height="18px" color="brand" />}
        <TileText truncate={truncate} lineClamp={lineClamp}>{label || value}</TileText>
      </TileContent>
    </Tile>
  );
};

TileButton.propTypes = {
  value: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string,
  truncate: PropTypes.bool,
  lineClamp: PropTypes.number,
  withIcon: PropTypes.bool,
  fullWidth: PropTypes.bool,
};

TileButton.defaultProps = {
  label: '',
  truncate: false,
  lineClamp: undefined,
  withIcon: false,
  fullWidth: false,
};

export { TileButton };
